var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "page",
    transform: "translate(-4038 -8208)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1317",
    "data-name": "Rectangle 1317",
    width: 24,
    height: 24,
    transform: "translate(4038 8208)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_654850314ac14d58ab3e207242c7602c",
    "data-name": "654850314ac14d58ab3e207242c7602c",
    d: "M7.33,11.315,6.081,15.677l4.363-1.248L18.86,6.012,15.747,2.9,7.33,11.315ZM16.172,4.8a.476.476,0,0,1,0,.671L9.591,12.05a.474.474,0,1,1-.67-.671L15.5,4.8a.476.476,0,0,1,.671,0Zm5.579-1.693-2.059,2.06L16.585,2.06,18.646,0l3.105,3.106ZM13.183,13.62l1.545-1.544V18.5H0V3.968L4.364.262H14.729v1.95L13.184,3.782V1.566H6.02V5.39H1.544V17.2H13.183V13.62Z",
    transform: "translate(4039.125 8210.751)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageSetting);
export default __webpack_public_path__ + "static/media/pageSetting.674044166b807014969a7000a63fe6cd.svg";
export { ForwardRef as ReactComponent };